export default {
  'Fort Smith': { lat: 60.0028, lon: -111.8844 },
  'Hay River': { lat: 60.8156, lon: -115.7994 },
  Inuvik: { lat: 68.36, lon: -133.7247 },
  Yellowknife: { lat: 62.454, lon: -114.3718 },
};
